import React, { useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery"; // Make sure you have jQuery or use a React-compatible solution
import "./OnionPage.css";

import img1 from "../../assets/img/onion.jpg";
import img2 from "../../assets/img/onion.jpg";
import img3 from "../../assets/img/onion.jpg";
import { EnquiryForm } from "./EnquiryForm";
export const CashewnutsPage = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);

    const openForm = () => {
      setIsFormOpen(true);
    };
  
    const closeForm = () => {
      setIsFormOpen(false);
    };
    const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => {
      setToggleState(index);
    };
    const [inputValue, setInputValue] = useState(1);
    const plus = () => {
      setInputValue(inputValue + 1);
    };
    const minus = () => {
      if (inputValue !== 0) {
        setInputValue(inputValue - 1);
      }
    };
    const [sliderValue, setSliderValue] = useState(50);
  
    const handleSliderChange = (value) => {
      setSliderValue(value);
    };
    const [isChecked, setIsChecked] = useState(false);
  
    const handleCheckboxChange = () => {
      setIsChecked(!isChecked);
    };
    const product = {
      title: "Onion",
      description: "5 Ton (MOQ)",
      oldPrice: 100.0,
      discountPrice: 75.0,
      images: [
        img1, // Example image paths
        img2,
        img3,
      ],
    };
  
    // State to manage the active image
    const [activeImage, setActiveImage] = useState(product.images[0]);
  
    // State for zoom effect
    const [zoomPosition, setZoomPosition] = useState({
      x: 0,
      y: 0,
      visible: false,
    });
  
    // Handle mouse movement for zoom effect
    const handleMouseMove = (e) => {
      const { left, top, width, height } = e.target.getBoundingClientRect();
      const x = ((e.pageX - left) / width) * 100;
      const y = ((e.pageY - top) / height) * 100;
      setZoomPosition({ x, y, visible: true });
    };
  
    // Hide zoom when the mouse leaves the image
    const handleMouseLeave = () => {
      setZoomPosition({ ...zoomPosition, visible: false });
    };
    //   useEffect(() => {
    //     // Autocomplete functionality using jQuery
    //     const availableCityTags = [
    //       "cubic meter", "cu. m.", "Cubic Centimeter", "ccm", "cm3", "Drum",
    //       "Drums", "Great Gross", "gr gr", "Gross", "gr", "Kilolitre", "kl",
    //       "Kilolitres", "Square yard", "Sq. Yd.", "Square yards", "Sq. Yds.",
    //       "Barrel", "Barrels", "hour", "hr", "hours", "hrs", "Millimeter", "mm",
    //       "Square Centimeter", "cm2", "Mile", "Cubic Inch", "in3",
    //       "Imperial Teaspoon", "Imperial tsp", "Imperial TableSpoon",
    //       "Imperial Tbsp", "Fluid Ounce", "fl oz", "Imperial Cup", "Imperial Pint",
    //       "Imperial Quart", "Imperial Gallon", "US teaspoon", "US tsp",
    //       "US Tablespoon", "US tbsp", "US Legal Cup", "US Liquid Pint",
    //       "US Liquid Quart", "US Liquid Gallon", "Minute", "Day", "Week", "Month",
    //       "Year", "Decade", "Century", "Nautical Mile", "nmi", "Acre", "milligram",
    //       "mg", "milligrams"
    //     ];
  
    //     $(".quantity_unit_class").autocomplete({
    //       minLength: 1,
    //       appendTo: "#quantity_unit_pop",
    //       source: availableCityTags,
    //     });
    //   }, []);
  
    return (
      <>
        <section className="onion-page-section">
          <div className="onion-page-container">
            <div className="details-left">
              <div className="producat_wrapper">
                <div
                  className="detailshome-zoom-container"
                  onMouseMove={handleMouseMove}
                  onMouseLeave={handleMouseLeave}
                >
                  <img
                    src={activeImage}
                    alt="Active Product"
                    className="detailshome-main-image"
                  />
                  {zoomPosition.visible && (
                    <div
                      className="detailshome-image-zoom-lens"
                      style={{
                        backgroundImage: `url(${activeImage})`,
                        backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                      }}
                    ></div>
                  )}
                </div>
                <div className="detailshome-image-gallery">
                  {product.images.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`Product ${index + 1}`}
                      onClick={() => setActiveImage(image)}
                      className={`detailshome-gallery-image ${
                        activeImage === image ? "detailshomeimageactive" : ""
                      }`}
                    />
                  ))}
                </div>
              </div>
              <div className="product-details-right">
                <h1 className="product-title">{product.title}</h1>
                <p className="product-description">{product.description}</p>
                <div className="product-rating">
                  <span>
                    <i className="fas fa-star"></i>
                  </span>
                  <span>
                    <i className="fas fa-star"></i>
                  </span>
                  <span>
                    <i className="fas fa-star"></i>
                  </span>
                  <span>
                    <i className="fas fa-star"></i>
                  </span>
                  <span>
                    <i className="fas fa-star-half-alt"></i>
                  </span>
                  <span>(350 ratings)</span>
                </div>
                <div className="onion-page-form-group">
                  <input
                    type="text"
                    id="quantity_unit"
                    className="quantity_unit_class"
                    placeholder="Quantity"
                  />
                  <input
                    type="text"
                    id="quantity_unit"
                    className="quantity_unit_class"
                    placeholder="Kilogram"
                  />
                  <button className="get-best-price">Buy Now</button>
                </div>
                <div className="product-details-content">
                  <div className="product-details-description">
                    <span>Business Type:</span>
                    Manufacturer, Exporter, Supplier
                  </div>
                  <div className="product-details-description">
                    <span>Application:</span>
                    Cooking
                  </div>
                  <div className="product-details-description">
                    <span>Color:</span>
                    Brown
                  </div>
                  <div className="product-details-description">
                    <span>Feature:</span>
                    Rich In Taste, Good Quality
                  </div>
                  <Link>
                    <p>Click to view More</p>
                  </Link>
                  <label htmlFor="">Preferred Buyer From</label>
  
                  <div className="product-details-description">
                    <span>Business Type:</span>
                    Manufacturer, Exporter, Supplier
                  </div>
                  <div className="product-details-button">
                    <button className="request-a-call">
                      <i className="fas fa-phone"></i>Request a Call
                    </button>
                    <button className="send-enquiry"  onClick={openForm}>
                      <i className="fa fa-envelope"></i>Send Enquiry
                    </button>
                    {isFormOpen && <EnquiryForm onClose={closeForm} />}
                  </div>
                </div>
              </div>
            </div>
  
            <div className="product-details">
              <h5>Product Details</h5>
              <div className="product-details-desc">
                <div className="product-details-description">
                  <span>Shelf Life </span>1 Year
                </div>
                <div className="product-details-description">
                  <span>Country of Origin </span>India
                </div>
                <div className="product-details-description">
                  <span>Cultivation Type </span>Natural
                </div>
                <div className="product-details-description">
                  <span>Processing Type </span>Raw
                </div>
                <div className="product-details-description">
                  <span>Certification FSSAI </span>Certified
                </div>
                <div className="product-details-description">
                  <span>Form </span>Powder
                </div>
              </div>
              <ul>
                <p>We also provide different quality Cumin Seeds</p>
                <li>IPM Cumin Seeds</li>
                <li>Non Polish Premium Quality Cumin</li>
                <li>Royal Cumin Seeds</li>
              </ul>
              <button className="interested-btn">Yes I am interested</button>
            </div>
           
          </div>
        </section>
      </>
    );
  };
  